import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clipboard"
export default class extends Controller {
  static targets = ["content", "subject", "button"]

  copy() {
    const subject = this.subjectTarget.textContent
    const content = this.contentTarget.textContent
    const fullText = `Betreff: ${subject}\n\n${content}`
    
    // Modern clipboard API
    if (navigator.clipboard) {
      navigator.clipboard.writeText(fullText).then(() => {
        this.showSuccess()
      }).catch((err) => {
        console.error('Fehler beim Kopieren:', err)
        this.fallbackCopy(fullText)
      })
    } else {
      this.fallbackCopy(fullText)
    }
  }

  fallbackCopy(text) {
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.style.position = 'fixed'
    textArea.style.opacity = '0'
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    
    try {
      document.execCommand('copy')
      this.showSuccess()
    } catch (err) {
      console.error('Fehler beim Kopieren:', err)
      alert('Fehler beim Kopieren. Bitte markieren Sie den Text manuell.')
    }
    
    document.body.removeChild(textArea)
  }
  
  showSuccess() {
    const originalText = this.buttonTarget.innerHTML
    this.buttonTarget.innerHTML = '<i class="bi bi-check-circle me-1"></i>Kopiert!'
    this.buttonTarget.classList.remove('btn-primary')
    this.buttonTarget.classList.add('btn-success')
    
    setTimeout(() => {
      this.buttonTarget.innerHTML = originalText
      this.buttonTarget.classList.remove('btn-success')
      this.buttonTarget.classList.add('btn-primary')
    }, 2000)
  }
}
